export const FORMAT_DATE = (input) => {
    let input_date = input.toString()
    let datePart = input_date.split('-'),
    year = datePart[0], // get only two digits
    month = datePart[1], day = datePart[2];

    return day + '/' + month + '/' + year;



}